import React from 'react';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface DialogCloseButtonProps extends IconButtonProps {
    handleClose: () => void;
    bold?: boolean;
}

export const DialogCloseButton = ({ handleClose, bold }: DialogCloseButtonProps) => {
    const { t } = useTranslation();
    const StyledDialogTitle = styled(IconButton)<IconButtonProps>(({ theme }) => ({
        position: 'absolute',
        right: 8,
        top: 8,
        color: bold ? theme.palette.grey[900] : theme.palette.grey[500]
    }));
    return (
        <StyledDialogTitle aria-label={t('CLOSE_LABEL')} onClick={handleClose}>
            <CloseIcon />
        </StyledDialogTitle>
    );
};

export {};
